import dayjs, { type Dayjs } from 'dayjs'

import { localeService } from '../services/localeService'

export const PACKAGE_BUSINESS_DATE_FORMAT = 'YYYY/MM/DD'

export const parsePackageBusinessDate = (value: string | null): Dayjs | null => {
  if (!value) {
    return null
  }

  const normalizedDate = localeService.parseDate(value)
  if (!normalizedDate) {
    return null
  }

  const parsed = dayjs(normalizedDate)
  return parsed.isValid() ? parsed : null
}

export const formatPackageBusinessDate = (value: string | null): string => {
  const parsed = parsePackageBusinessDate(value)
  return parsed ? parsed.format(PACKAGE_BUSINESS_DATE_FORMAT) : '-'
}

export const formatPackageFormDate = (value?: Dayjs | null): string =>
  value && value.isValid() ? value.format(PACKAGE_BUSINESS_DATE_FORMAT) : ''

export const packageBusinessDateToIsoString = (
  value?: Dayjs | null
): string | null => (value ? value.toISOString() : null)

export const isSamePackageBusinessDate = (
  originalValue: string | null,
  formValue?: Dayjs | null
): boolean => {
  const originalDate = parsePackageBusinessDate(originalValue)
  if (!originalDate || !formValue) {
    return originalDate === null && !formValue
  }
  return originalDate.isSame(formValue, 'day')
}
